import React from 'react';
import { Row } from 'react-bootstrap';
import {
  SiVisualstudiocode,
  SiAndroidstudio,
  SiGit,
  SiPostman,
  SiVercel,
  SiKibana,
  SiFigma,
  SiSwagger,
  SiCanva,
  SiUnity,
} from 'react-icons/si';
import IconBox from './widgets/icon_box';

const Toolstack = () => {
  return (
    <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
      <IconBox Icon={SiVisualstudiocode} text='VS Code'></IconBox>
      <IconBox Icon={SiAndroidstudio} text='Android Studio'></IconBox>
      <IconBox Icon={SiGit} text='Git'></IconBox>
      <IconBox Icon={SiSwagger} text='Swagger'></IconBox>
      <IconBox Icon={SiPostman} text='Postman'></IconBox>
      <IconBox Icon={SiVercel} text='Vercel'></IconBox>
      <IconBox Icon={SiKibana} text='Kibana'></IconBox>
      <IconBox Icon={SiUnity} text='Unity'></IconBox>
      <IconBox Icon={SiFigma} text='Figma'></IconBox>
      <IconBox Icon={SiCanva} text='Canva'></IconBox>
    </Row>
  );
};

export default Toolstack;
